import {FC, ReactNode} from 'react'
import {KTIcon} from '@/_metronic/helpers'

type Props = {
  icon: string
  color: string
  title: ReactNode
  value: ReactNode
}

const IndicatorCard: FC<Props> = ({icon, color, title, value}) => {
  return (
    <div className={`card bg-${color} hoverable card-xl-stretch mb-xl-2`}>
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <KTIcon iconName={icon} className='fs-3x text-white me-1' />
          <div className="text-white fw-bold fs-2">{value}</div>
        </div>
        <div className="text-white fw-bold fs-2">{title}</div>
      </div>
    </div>
  )
}

export {IndicatorCard}
